// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bHzO","colBig":"styles_colBig__2lAmq","colSmall":"styles_colSmall__3HdyB"};